import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Box from 'grommet/components/Box'
import Heading from 'grommet/components/Heading'
import Paragraph from 'grommet/components/Paragraph'

import slidesSelector from '../selectors/slides'

import Footer from '../components/Footer'
import Header from '../components/Header'
import Slider from '../components/Slider'

import '../styles/SidebarSlideshow.css'

class SidebarSlideshow extends Component {
  render () {
    const {
      title,
      subtitle
    } = this.props.data

    return (
      <div className='SidebarSlideshow'>
        <Header />

        <Box align='center'>
          <Heading align='center' margin='none'>{title}</Heading>
          <Paragraph align='center' size='large'>{subtitle}</Paragraph>
        </Box>

        <div className='flex-container'>
          <div className='sidebar'>
            {/* Sidebar content */}
          </div>

          <div className='Slideshow'>
            <Box align='center'>
              <Slider slides={this.props.slides} />
            </Box>
          </div>
        </div>

        <Footer
          isRoot={this.props.isRoot}
          history={this.props.history} />
      </div>
    )
  }
}

SidebarSlideshow.propTypes = {
  data: PropTypes.object,
  slides: PropTypes.array,
  history: PropTypes.object,
  isRoot: PropTypes.bool
}

const mapStateToProps = (state, ownProps) => {
  const {
    slideIds
  } = ownProps.data

  return {
    slides: slidesSelector(state, slideIds)
  }
}

export default connect(mapStateToProps)(SidebarSlideshow)



// WEBPACK FOOTER //
// ./src/layouts/SidebarSlideshow.js